import n1ql from "refractor/n1ql";
export default n1ql;